import eventBus from '@refapp/eventbus-js';

export default {
  data() {
    return {
      hideBuyNowButton: '',
      loading: false,
      productItemId: '',
    };
  },
  methods: {
    getdata(values) {
      fetch(
        `/refapp/multipleclicktobuy/getretailers?productItemId=${values.productItemId}&varintItemId=${values.varintItemId}`,
      )
        .then((resp) => resp.text())
        .then((resp) => {
          this.buynowData = JSON.parse(JSON.parse(resp).Json);
          this.hideBuyNowButton = this.buynowData.HideBuyNowButton;
          this.loading = true;
        });
    },
  },
  created() {
    eventBus.on('rfp-mctb-has-variant-component', (val) => this.getdata(val));
    window.eventBus.$on('rfp-mctb-has-variant-component', (val) => this.getdata(val));

    eventBus.on('this.datas.Product.ProductId', (val) => (this.productItemId = val));
    window.eventBus.$on('this.datas.Product.ProductId', (val) => (this.productItemId = val));
  },
};
